<script setup lang="ts">
/** A pushpin: filled when the view is pinned, outlined when it can be. */
defineProps<{ filled?: boolean }>();
</script>

<template>
  <svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true">
    <path
      d="M6 1.75h4M6.75 1.75v4.1L4.5 8.6v1.15h7V8.6L9.25 5.85v-4.1M8 9.75v4.5"
      :fill="filled ? 'currentColor' : 'none'"
      stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"
    />
  </svg>
</template>
